module.exports = __webpack_public_path__ + "img/qd-img-4.70613425.jpg";